import { render } from "./activate.vue?vue&type=template&id=2e3d79e8&ts=true"
import script from "./activate.vue?vue&type=script&lang=ts"
export * from "./activate.vue?vue&type=script&lang=ts"

import exportComponent from "/drone/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__